<!--
 * @Description: 活码详情页面
 * @Author: mdb
 * @Date: 2023-04-17 16:12:02
 * @LastEditTime: 2023-04-19 15:31:36
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent style="margin-top: 0">
        <DetailForm type="view" title="活码详情" paramCode="zbu_source_channel_fbu" subdomain="fbu" />
      </CosViewContent>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import DetailForm from '@/views/marketing/marketingManage/activityCode/components/DetailForm.vue'
</script>
<script lang="ts">
export default { name: 'DcCosFbuActivityCodeView' }
</script>

<style scoped></style>
